<template>
  <div class="order_status"  ref="order_status" @scroll="scrollHandle($event)">
    <div :class="{ isiOSX: isiOSX }" class="nav_bar_box" ref="nav_bar_box">
      <van-row class="nav_bar" ref="nav_bar">
        <van-col span="17" @click="reBack()">
          <van-icon name="arrow-left" class="back_icon" />
        </van-col>

        <van-col class="tel_col sca09">
          <a href="tel:4000571671" @click="iOStel('4000571671')">
            <div class="img-box1">
              <img
                class="nav_img mar_le15"
                :src="header_img ? header_tel_black : header_tel_white"
              />
            </div>
            <p class="tel_center">客服电话</p>
          </a>
        </van-col>
        <van-col class="hel_col sca09" @click="handleCustomerService()">
          <div class="img-box1">
            <img
              class="nav_img"
              :src="header_img ? header_help_black : header_help_white"
            />
          </div>
          <p class="tel_center">帮助</p>
        </van-col>
      </van-row>
    </div>
    <!-- <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    > 
  <div>-->
    <div class="order_header_body">
      <div class="order_header">
        <van-row class="oh_title">
          <van-col span="12" class="oh_status">
            {{ status_text }}
          </van-col>
          <van-col
            v-if="
              dataSource && dataSource.status === 10 && downCount !== '00:00'
            "
            span="12"
            class="oh_time"
            >{{ downCount }}后自动关闭</van-col
          >
        </van-row>
        <p class="oh_osn">
          您的订单号为&nbsp;{{ dataSource && dataSource.order_sn }}
        </p>
      </div>
      <div class="ope_body">
        <div class="ope_box">
          <div
            v-if="
              dataSource.is_after_sales === 20 ||
                dataSource.is_after_sales === 10
            "
          >
            <p class="ope_title">
              您已提交退订申请，正在处理中…
            </p>
          </div>
          <div v-else-if="dataSource.is_after_sales === 30">
            <p class="ope_title">
              您的订单已退订成功
            </p>
          </div>
          <div v-else-if="dataSource.is_after_sales === 40">
            <p class="ope_title">
              您的订单退款失败，请联系客服处理。
            </p>
          </div>
           <div
            v-else-if="
              dataSource.status === -20 "
          >
            <p class="ope_title">
              酒店确认失败。
            </p>
          </div>
          <div v-else-if="dataSource.status === 10">
            <p class="ope_title">
              你还没有支付订单，请尽快支付～
            </p>
            <p class="ope_time">
              北京时间{{
                dataSource.can_cancel_time
              }}前可免费取消此订单，逾期无法取消或退款
            </p>
          </div>
          <div v-else-if="dataSource.status === 25 || dataSource.status === 20">
            <p class=" successfully">
              您的订单已支付成功，我们会尽快与服务商确认，请您耐心等待。
            </p>
            <p class="ope_time">
              北京时间{{ dataSource.can_cancel_time }}前可免费取消此订单，逾期无法取消或退款
            </p>
          </div>
          <div v-else-if="dataSource.status === 30">
            <p class=" ope_title">
              订单已预订成功，您可以放心入住。
            </p>
            <p class="ope_time">
              北京时间{{ dataSource.can_cancel_time }}前可免费取消此订单，逾期无法取消或退款
            </p>
          </div>
          <div v-else-if="dataSource.status === 40 || dataSource.status === 50">
            <p class="ope_title">
              您已入住该酒店，祝您旅途愉快～
            </p>
          </div>

          <div
            v-else-if="dataSource.status === -10"
          >
            <p class="ope_title">
            {{dataSource.cause_of_failure ? '取消原因：'+ (dataSource.cause_of_failure.indexOf("其他原因") != -1 ? '其他原因':dataSource.cause_of_failure) : '倒计时结束，订单自动关闭。'}}
            </p>
          </div>

          <van-row
            class="ope_btn_box marTo20"
            v-if="
              dataSource.is_after_sales === 20 ||
                dataSource.is_after_sales === 10
            "
          >
            <van-col span="24">
              <van-button
                type="default"
                class="submit_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box marTo20"
            v-else-if="dataSource.is_after_sales === 40"
          >
            <van-col span="11">
              <van-button
                type="default"
                class="can_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11">
              <a href="tel:4000571671" @click="iOStel('4000571671')">
                <van-button type="default" class="submit_btn"
                  >联系客服</van-button
                >
              </a>
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box marTo20"
            v-else-if="dataSource.is_after_sales === 30"
          >
            <van-col span="11">
              <van-button type="default" class="can_btn" @click="handleDel()"
                >删除订单</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11">
              <van-button
                type="default"
                class="submit_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
          </van-row>
          <van-row class="ope_btn_box" v-else-if="dataSource.status === 10">
            <van-col span="11">
              <van-button type="default" class="can_btn" @click="handleCancel()"
                >取消订单</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11">
              <van-button
                type="default"
                class="submit_btn"
                @click="handleToPay()"
                >去支付</van-button
              >
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box"
            v-else-if="dataSource.status === 20 || dataSource.status === 25"
          >
            <van-col span="24">
              <van-button
                type="default"
                class="submit_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
          </van-row>
          <van-row class="ope_btn_box" v-else-if="dataSource.status === 30">
            <van-col span="7">
              <van-button
                type="default"
                class="can_btn fontsi5"
                @click="handleCancel()"
                >取消订单</van-button
              >
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="8">
              <van-button
                type="default"
                :disabled= "dataSource.is_push_msg"
                class="can_btn fontsi5"
                @click="handlelSendLetter()"
                >{{dataSource.is_push_msg ? '已发确认函' : '重发确认函'}}</van-button
              >
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="7">
              <van-button
                type="default"
                class="submit_btn fontsi5"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box marTo20"
            v-else-if="
              dataSource.status === 40
            "
          >
            <van-col span="11">
              <van-button
                type="default"
                class="can_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11">
              <van-button
                type="default"
                class="submit_btn bg_org"
                @click="handleGetCredits()"
                >领取积分</van-button
              >
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box marTo20"
            v-else-if="
              dataSource.status === 50
            "
          >
            <van-col span="7">
              <van-button
                type="default"
                class="can_btn fontsi5"
                @click="handleDel()"
                >删除订单</van-button
              >
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="7">
              <van-button
                type="default"
                class="submit_btn fontsi5"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="8">
              <van-button
                type="default"
                class="submit_btn bg_org_op fontsi5"
                @click="handleReceived()"
                >积分已领取</van-button
              >
            </van-col>
          </van-row>
          <van-row
            class="ope_btn_box marTo20"
            v-else-if=" dataSource.status === -10|| dataSource.status === -20"
          >
            <van-col span="11">
              <van-button type="default" class="can_btn" @click="handleDel()"
                >删除订单</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11">
              <van-button
                type="default"
                class="submit_btn"
                @click="handleReserve()"
                >再次预订</van-button
              >
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="order_detail">
      <van-row class="ma_bo_20">
        <van-col span="6" class="or_de_33">{{
          dataSource.status === 10 ? "需支付" : "在线支付"
        }}</van-col>
        <van-col
          span="8"
          :class="
            (dataSource.status === -10 || dataSource.status === -20 ) &&
            dataSource.is_after_sales !== 10 &&
            dataSource.is_after_sales !== 40 &&
            dataSource.is_after_sales !== 20 &&
            dataSource.is_after_sales !== 30
              ? 'or_de_co66'
              : 'or_de_money'
          "
          >¥&nbsp;{{ dataSource && dataSource.pay_money && dataSource.pay_money.toFixed(2) }}</van-col
        >
        <van-col
          span="10"
          :class="
            (dataSource.status === -10 || dataSource.status === -20 ) &&
            dataSource.is_after_sales !== 10 &&
            dataSource.is_after_sales !== 40 &&
            dataSource.is_after_sales !== 20 &&
            dataSource.is_after_sales !== 30
              ? 'or_de_co66 or_de_discount'
              : 'or_de_discount'
          "
          >红包抵扣:&nbsp;¥{{dataSource &&  dataSource.deduct_coin && dataSource.deduct_coin.toFixed(2) }}</van-col
        >
      </van-row>
      <van-row
        class="or_de_bo20"
        v-if="
          ( dataSource.status === -10 || dataSource.status === -20 ) &&
            dataSource.is_after_sales !== 10 &&
            dataSource.is_after_sales !== 40 &&
            dataSource.is_after_sales !== 20 &&
            dataSource.is_after_sales !== 30
        "
      >
        <van-col span="24" class="re_points"
          >抵扣的红包稍后会退回您账户</van-col
        >
      </van-row>
      <van-row
        :class="[
           dataSource.status === -10 || dataSource.status === -20 
            ? 'or_de_bo10 '
            : 'or_de_bo20',
        ]"
        v-if="
          (dataSource.status === 20 ||
            dataSource.status === 25 ||
            dataSource.status === -10 ||
            dataSource.status === -20 ||
            dataSource.status === 30 ||
            dataSource.status === 40 ||
            dataSource.status === 50) &&
            dataSource.is_after_sales !== 10 &&
            dataSource.is_after_sales !== 40 &&
            dataSource.is_after_sales !== 20 &&
            dataSource.is_after_sales !== 30
        "
      >
        <van-col span="6" class="or_de_33">赠积分</van-col>
        <van-col
          span="8"
          :class="
             dataSource.status === -10 || dataSource.status === -20 
              ? 'or_de_integral or_de_co66'
              : 'or_de_integral'
          "
          >{{ dataSource.return_credits.toFixed(2) }}</van-col
        >
        <van-col
          span="10"
          :class="
            dataSource.status === -10 || dataSource.status === -20 
              ? 'or_de_give or_de_co66'
              : 'or_de_give'
          "
          >离店后赠送</van-col
        >
      </van-row>
      <div
        v-if="
          dataSource.is_after_sales === 10 ||
            dataSource.is_after_sales === 40 ||
            dataSource.is_after_sales === 20 ||
            dataSource.is_after_sales === 30
        "
      >
        <van-row class="or_de_bo20">
          <van-col span="6">退款进度</van-col>
        </van-row>
        <van-row class="">
          <van-col span="24" class="or_de_account"
            >退回{{
              dataSource.pay_type === 1
                ? "银联"
                : dataSource.pay_type === 2
                ? "支付宝"
                : dataSource.pay_type === 3
                ? "微信"
                : "余额"
            }}账户¥{{ dataSource.pay_money.toFixed(2) }}</van-col
          >
        </van-row>
        <!-- http://others-qiniu.shall-buy.com/others-icon-20210220092116268832.png -->
        <!-- http://others-qiniu.shall-buy.com/others-icon-20210219163659406896.png -->
        <van-steps
          :active="
            dataSource.is_after_sales === 10
              ? 0
              : dataSource.is_after_sales === 20
              ? 1
              : 2
          "
          :class="dataSource.is_after_sales === 40 ? 'step_body' : ''"
          inactive-icon="passed"
          :active-icon="dataSource.is_after_sales === 40 ? 'clear' : 'checked'"
        >
          <van-step>
            <div class="step_div">
              <p class="step_title">销巴已受理</p>
              <p class="step_time">
                {{
                  dataSource.created_at.substring(
                    dataSource.created_at.indexOf("-") + 1
                  )
                }}
              </p>
            </div>
          </van-step>
          <van-step class="step_divs">
            <div class="step_div">
              <p class="step_title">{{dataSource.is_after_sales === 30 ? '销巴已退款' : '退款中'}}</p>
              <p class="step_time">
                {{
                  dataSource.confirm_date &&
                    dataSource.confirm_date.substring(
                      dataSource.confirm_date.indexOf("-") + 1
                    )
                }}
              </p>
            </div>
          </van-step>
          <van-step>
            <div class="step_div">
              <p class="step_title">{{ dataSource.is_after_sales === 40 ? "退款失败" : "退款成功" }}</p>
              <p class="step_time">
                {{
                  dataSource.finish_date &&
                    dataSource.finish_date.substring(
                      dataSource.finish_date.indexOf("-") + 1
                    )
                }}
              </p>
            </div>
          </van-step>
        </van-steps>
      </div>

      <van-row class="or_de_bo20">
        <van-col span="6">执行方</van-col>
        <van-col span="18" class="or_de_co66 executive">携程</van-col>
      </van-row>
      <div  @click="handleHotelDetail()">
      <van-row class="or_de_bo5">
        <van-col span="18" class="or_de_hotel_name">{{
          info && info.hotel_name
        }}</van-col>
        <van-col span="6" class="or_de_arrow"
          >酒店详情<van-icon name="arrow" class="arrow"
        /></van-col>
        </van-row>
        <p class="or_de_address">地址：&nbsp;{{ info && info.address }}</p>
      </div>
      <van-row class="or_de_bo30">
        <van-col v-if="!this.$route.query.type" span="4" class="or_de_addressBox" @click="handleLocation()">
          <img src="../../../assets/hotel/img/order/address.png" />
          <p>酒店位置</p>
        </van-col>
        <van-col span="2" v-if="!this.$route.query.type" ></van-col>
        <van-col span="4" class="or_de_telBox">
          <a :href="'tel:' + infoTel" @click="iOStel(infoTel)"
            ><img src="../../../assets/hotel/img/order/tel_order.png" />
            <p>致电酒店</p></a
          ></van-col
        >
      </van-row>
      <van-row class="or_de_bo15">
        <van-col span="8" class="or_de_99">入离时间</van-col>
        <van-col span="16" class="or_de_co_33"
          >{{ dataSource.arrival_date
          }}<span class="or_de_day_number">{{ dataSource.day_number }}晚</span
          >{{ dataSource.departure_date }}</van-col
        >
      </van-row>
      <van-row class="or_de_bo15">
        <van-col span="8" class="or_de_99">房间及间数</van-col>
        <van-col span="16" class="or_de_co_33"
          >{{ info.room_name }}，{{ dataSource.room_number }}间</van-col
        >
      </van-row>
      <van-row class="or_de_bo15">
        <van-col span="8" class="or_de_99">餐食</van-col>
        <van-col span="16" class="or_de_co_33">{{
          info.breakfast ? info.breakfast : "不含餐"
        }}</van-col>
      </van-row>
      <van-row class="or_de_bo15">
        <van-col span="8" class="or_de_99">入住人</van-col>
        <van-col span="16"
          ><span
            v-for="(item, index) in customer_person"
            :key="index"
            class="or_de_co_33"
          >
            {{ item.Name }}
          </span></van-col
        >
      </van-row>
      <van-row class="or_de_bo30">
        <van-col span="8" class="or_de_99">电话联系人</van-col>
        <van-col span="16" class="or_de_co_33"
          >{{ phone_call
          }}<img
            class="tel_show"
            @click="handleShow()"
            :src="telShow ? close_tel_img : show_tel_img"
        /></van-col>
      </van-row>
      <van-row @click="handleDetail()">
        <van-col span="14" class="or_de_more">查看更多订单详情</van-col>
        <van-col span="10" class="or_de_more_icon"
          ><van-icon name="arrow"
        /></van-col>
      </van-row>
      <!-- <van-row class="guess_like">
        <van-col span="24">猜你喜欢</van-col>
      </van-row> -->
    </div>
    <div v-if="info.hotel_id"><guess-order :hotel_id="info.hotel_id" /></div>
   <!-- </div>
     </van-pull-refresh> -->
    <van-popup v-model="show">
      <div class="box">
        <img src="../../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">亲，您真的要删除该订单吗？</p>
        <span class="left" @click="cancle()">取消</span>
        <span class="right" @click="confirm()">确认</span>
      </div>
    </van-popup>

    <div class="order-detail-loading" v-if="loading1">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import "@/assets/hotel/css/reset.css";
import guessOrder from "./guessOrder.vue";
import dsbridge from "dsbridge";
import { mapState, mapMutations } from "vuex";
import {
  getCredits,
  sendLetter,
  delOrder,
  getOrderDetail,
  getCancel,
  getPayment,
  getHotelDetail,
} from "@/pages/hotel/api";
export default {
  data() {
    return {
      dataSource: {},
      status_text: "",
      downCount: "00:00",
      tel: "",
      phone_call:"",
      telShow: false,
      mobile: "",
      customer_person: [],
      info: {},
      header_help_black: require("@/assets/hotel/img/order/help_black.png"),
      header_help_white: require("@/assets/hotel/img/order/help.png"),
      header_tel_black: require("@/assets/hotel/img/order/tel_black.png"),
      header_tel_white: require("@/assets/hotel/img/order/tel.png"),
      show_tel_img: require("@/assets/hotel/img/order/show_tel.png"),
      close_tel_img: require("@/assets/hotel/img/order/close_tel.png"),
      id: this.$route.query.order_sn,
      show: false,
      header_img: false,
      facility: "",
      loading1: false,
      coordinate :{},
      infoTel:'',
      // isLoading: false,
    };
  },
  components: {
    guessOrder,
  },
  created() {
     if(sessionStorage.coordinate){
        this.coordinate = JSON.parse(sessionStorage.getItem("coordinate"));
      }
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad();
  },
  computed: {
    ...mapState({
      hotel: (state) => state.hotel,
    }),
  },
  mounted() {
    //   document.body.addEventListener('touchmove', function (e) {
    //     e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
    // }, {passive: false}) // passive 参数不能省略，用来兼容ios和android
   
    window.setPay = this.setPay;
    this.deductionUA();
    setTimeout(() => {
      if (
        this.dataSource.is_after_sales === 10 ||
        this.dataSource.is_after_sales === 20 ||
        this.dataSource.is_after_sales === 30 ||
        this.dataSource.is_after_sales === 40
      ) {
        const body = document.querySelector(".step_body");
        const dom = body.querySelector(".van-step--process");
        if (dom) {
          dom
            .querySelector(".step_title")
            .classList.add("step_title_err", "step_title");
          dom
            .querySelector(".step_time")
            .classList.add("step_title_err", "step_time");
        }
      }
    }, 1500); 
  },
  methods: {
    ...mapMutations(["setState"]),
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$toast("支付成功");
        this.loading1 = true;
        let countLimit1 = 0;
        const intervalId1 = setInterval(() => {
          countLimit1++;
          if (this.dataSource.status === 20) {
            clearInterval(intervalId1);
            this.loading1 = false;
            return;
          }
          this.onLoad();
          if (countLimit1 >= 5) {
            clearInterval(intervalId1);
            this.loading1 = false;
          }
        }, 1000);
      } else {
        this.$toast("支付失败");
      }
    },
    //  onRefresh() {
    //   setTimeout(() => {
    //     this.isLoading = false;
    //   }, 1000);
    // },
  // },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    //滚动事件
    scrollHandle(e) {
      if (!e) {
        return;
      }
      const top = e.target.scrollTop;
      if (top > 10) {
        this.$refs.nav_bar_box.classList.add("bgckimg_ff");
        this.$refs.nav_bar.$el.style.color = "#333";
        this.header_img = true;
        //  this.$refs.order_status.style.overflow = "scroll";
      } else {
        this.$refs.nav_bar_box.classList.remove("bgckimg_ff");
        this.$refs.nav_bar.$el.style.color = "#fff";
        this.header_img = false;
        // if(top<=0){
          // this.$refs.order_status.style.overflow = "hidden";
          // setTimeout(() => {
          //    document.querySelector('.order_status').scrollTop = 0
          // }, 1000);
        //   document.querySelector('.order_status').scrollTop = 0
        // }
      }
    },
    onLoad() {
      // sessionStorage.setItem("longitude", "116.481777");
      // sessionStorage.setItem("latitude", "39.910844");
      getOrderDetail({
        order_sn: this.id,
        longitude:this.$route.query.type ?  "116.481777" : this.coordinate && this.coordinate.longitude,
        latitude:this.$route.query.type ? "39.910844" : this.coordinate && this.coordinate.latitude,
        // longitude: sessionStorage.getItem("longitude"),
        // latitude: sessionStorage.getItem("latitude"),
      })
        .then((data) => {
          this.dataSource = data;
          const { info, contact_phone } = data;
          const { customer_person } = info;
          this.customer_person = customer_person || [];
          this.info = info;
          this.mobile = contact_phone;
          this.phone_call = this.showTel(contact_phone);
          this.infoTel = info &&info.tel && info.tel[0];
          switch (data.status) {
            case -20:
              this.status_text = "已关闭";
              break;
            case 10:
              this.status_text = "待支付";
              break;
            case 20:
              this.status_text = "预订待处理";
              break;
            case 25:
              this.status_text = "预订待处理";
              break;
            case 30:
              this.status_text = "预订成功";
              break;
            case 40:
              this.status_text = "已完成";
              break;
            case 50:
              this.status_text = "已完成";
              break;
            case -10:
              this.status_text = "已关闭";
              break;
          }
          switch (data.is_after_sales) {
            case 10:
              this.status_text = "退订中";
              break;
            case 20:
              this.status_text = "退订中";
              break;
            case 30:
              this.status_text = "已退订";
              break;
            case 40:
              this.status_text = "退订中";
              break;
          }
          if (data.not_pay_cancel_time) {
            this.setTimer(this.date2timestamp(data.not_pay_cancel_time));
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    handleShow() {
      this.telShow = this.telShow ? false : true;
      this.phone_call = this.telShow ? this.mobile : this.showTel(this.mobile);
    },
    handleDetail() {
      this.$router.push({
        path: "/hotel/orderDetail",
        query: {
          order_sn: this.id || this.dataSource.order_sn,
        },
      });
    },
    handleHotelDetail() {
      this.$router.push({
        path: "/hotel/detail",
        query: {
          hotel_id: this.info.hotel_id,
          back: "order",
        },
      });
    },
    //取消订单
    handleCancel() {
      this.$router.push({
        path: "/hotel/cancelOrder",
        query: {
          order_sn: this.id || this.dataSource.order_sn,
          routing: "status",
        },
      });
    },
    //酒店位置
    handleLocation() { 
       getHotelDetail(this.info.hotel_id, this.coordinate.longitude, this.coordinate.latitude).then((res) => {
         let transport = ''
          for (let i in res.transport) {
          if (res.transport[i].Directions != "") {
            transport =
              "距" + res.transport[i].Name + res.transport[i].Directions;
            break;
          }
        }
         this.$router.push({
        path: "/hotel/position",
        query: {
          chinese_name: res.chinese_name,
          latitude: res.latitude,
          longitude: res.longitude,
          distance: this.dataSource.distance,
          business_district: res.business_district,
          transport: transport,
          start_name: this.hotel.searchCity.name,
          end_name: res.geo.City.Name,
        },
      });
       }).catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
          // this.error = true
          // this.refreshing = false
        });
    },
    handleClose() {
      getCancel({
        order_sn: this.id || this.dataSource.order_sn,
        cancel_reason: "倒计时结束，订单自动关闭。",
      })
        .then((res) => {
          this.onLoad();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //去支付
    handleToPay() {
      getPayment({ order_sn: this.dataSource.order_sn })
        .then((res) => {
          //支付金额订单红包折扣订单编号订单类型
          const param = {
            actual_amount: this.dataSource.pay_money,
            order_amount: this.dataSource.order_money,
            ordersn: this.dataSource.order_sn,
            order_type: "hotelv2",
          };
          if (this.facility == "ios") {
            let that = this;
            dsbridge.call("goPay", JSON.stringify(param), function(v) {
              that.setPay(v);
            });
          } else if (this.facility == "android") {
            this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //再次预订
    handleReserve() {
      this.$router.push({
        path: "/hotel/detail",
        query: {
          hotel_id: this.info.hotel_id,
          back: "order",
        },
      });
    },
    //重发确认函
    handlelSendLetter() {
      sendLetter({
        order_sn: this.id || this.dataSource.order_sn,
      })
        .then((res) => {
          this.$toast("操作成功~");
          this.onLoad();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //帮助
    handleCustomerService() {
      this.params("6", "6", "customerService");
    },
    //领取积分
    handleGetCredits() {
      getCredits({
        order_sn: this.id || this.dataSource.order_sn,
      })
        .then((res) => {
          this.$toast("您已成功领取积分");
          this.onLoad();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //删除订单
    handleDel() {
      this.show = true;
    },
    confirm() {
      delOrder({
        order_sn: this.id || this.dataSource.order_sn,
      })
        .then((res) => {
          this.$toast("删除成功");
          this.show = false;
          this.$router.push({
            path: "/hotel/myOrder",
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    cancle() {
      this.show = false;
    },
    //已领取积分
    handleReceived() {
      this.$toast("已领取积分");
    },
    //联系客服
    iOStel(phoneString) {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    },
    showTel(params) {
      let tel = params.replace(/(\d{3})(\d{4})(\d{4})/, "*******$3");
      return tel;
    },
    setTimer(end_time) {
      var _that = this;
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = end_time - current;
      if (ts <= 0) {
        _that.downCount = "00:00";
        clearInterval(timer);
        //  this.onLoad();
        // if(this.info.list_extend.status == 1) {
        // 	this.info.list_extend.status = -2
        // }
        return false;
      } else {
        _that.getTimeCount(ts, _that);
      }
      var timer = setInterval(function() {
        var current = Math.floor(new Date().getTime() / 1000);
        var ts = end_time - current;
        if (ts <= 0) {
          _that.downCount = "00:00";
          clearInterval(timer);
          _that.handleClose();
        } else {
          _that.getTimeCount(ts, _that);
        }
      }, 1000);
    },
    //支付时间倒计时
    getTimeCount(ts, _that) {
      var mm = parseInt((ts / 60) % 60, 10);
      var ss = parseInt(ts % 60, 10);
      this.downCount = _that.checkTime(mm) + ":" + _that.checkTime(ss);
    },
    reBack() {
      this.$router.push({
        path: "/hotel/myOrder",
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle());
  },
};
</script>
<style lang="less" scoped>
// html {
//   font-size: calc(var(--sizeScale2) * 1px);
// }
/deep/ .van-step__icon {
  font-size: 22px !important;
}
/deep/ .van-steps__items {
  padding-bottom: 10px !important;

}
/deep/ .van-step--finish {
  .van-icon-checked {
    // background: linear-gradient(to right, #0fbf6d, #108b30);
    // background-clip: text;
    // color: transparent;
    color: #108b30;
  }
}
/deep/ .step_title_err {
  color: #f84737 !important;
}
/deep/ .van-icon-clear {
  color: #f84737 !important;
}
/deep/ .van-step--process {
  .van-icon-checked {
    // background: linear-gradient(to right, #0fbf6d, #108b30);
    // background-clip: text;
    // color: transparent !important;
    color: #108b30;
  }
}
</style>
<style lang="less">
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.order_status {
  // background: url(../../../assets/hotel/img/order/head_bg.png) no-repeat;
  // background-size: 100% ;
  font-weight: 600;
  height: 100%;
  overflow: scroll;
  background: #fbfbfb;
  .nav_bar {
    width: calc(100% - 2rem);
    margin: 0 auto;
    color: #fff;
    font-size: 1.2rem;
  }
  .back_icon {
    font-size: 2rem;
    line-height: 4.4rem;
  }
  .hel_col {
    float: right;
    margin-right: 0.6rem;
  }
  .hel_col img {
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
  }
  .tel_center {
    text-align: center;
  }
  .tel_col {
    float: right;
  }
  .tel_col img {
    margin-left: 2.4rem;
  }
  .tel_col span {
    margin-left: 1rem;
  }
  .nav_bar_box {
    height: 4.4rem;
    position: fixed;
    top: 0;
    left: -0.1rem;
    right: 0;
    width: 100%;
    z-index: 9999999;
    padding-top: 4.4rem;
    // background-image: linear-gradient(to right, #07bb67, #2a9646);
    // background-image: linear-gradient(to right, #15b966, #279a45);
    background: url(../../../assets/hotel/img/order/head_bg.png) no-repeat;
    background-size: 101%;
  }
  .nav_img {
    width: 1.6rem;
    height: 1.6rem;
  }
  .img-box1 {
    width: 100%;
    text-align: center;
  }
  .img-box1 img {
    margin: 0.5rem auto 0 !important;
  }

  .mar_le15 {
    // margin-left: 15rem;
  }
  .sca09 {
    transform: scale(0.9);
    display: inline-block;
    margin-top: 0.2rem;
  }
}
.order_header_body {
    font-weight: 600;
  position: relative;
  // top:8.8rem;
  background: url(../../../assets/hotel/img/order/head_bg.png) no-repeat;
  background-size: 101% 80%;
  // background-size: 101% 70%;
  // background-position:top;
  // margin-top: 8.8rem;
  padding-top: 8.8rem;
  padding-bottom: 2.8rem;
  .order_header {
    // padding: 44px 0 0;
    // background-image: linear-gradient(to right, #0fbf6d, #108b30);
    margin-top: 1rem;
    color: #fff;
    margin-bottom: 8rem;
  }
  .oh_title {
    width: calc(100% - 2rem);
    margin: 0 auto;
  }
  .oh_status {
    font-size: 2.4rem;
  }
  .oh_time {
    font-size: 1.8rem;
    text-align: right;
  }
  .oh_osn {
    width: calc(100% - 2rem);
    margin: 0.5rem auto;
    font-size: 1.4rem;
    margin-bottom: 1.6rem;
    font-weight: normal;
  }
}
.bgckimg_ff {
    font-weight: 600;
  box-shadow: 0px 0px 1.1rem #e4dddd;
  background-image: linear-gradient(#fff, #fff) !important;
}
.ope_body {
    font-weight: 600;
  width: calc(100% - 2rem);
  margin: 0 auto;
  border-radius: 1.6rem;
  box-shadow: 0 0 4rem #c5c5c5;
  z-index: 999;
  background: #fff;
  position: relative;
  left: 47.4%;
  transform: translate(-50%, 0%);
  margin-top: -6.5rem;
  .ope_box {
    padding: 1.5rem;
  }
  .ope_title {
    color: #333333;
    font-size: 1.3rem;
    margin-top: 0.6rem;
  }
  .ope_time {
    color: #108b30;
    font-size: 1.2rem;
    margin: 1rem 0 2rem;
    font-weight: normal;
  }
  .successfully {
    color: #333333;
    font-size: 1.3rem;
  }
  .ope_btn_box {
    padding: 0 0 0.3rem;
  }
  .can_btn {
    height: 4rem;
    width: 100%;
    line-height: 4rem;
    border-radius: 2rem;
    font-size: 1.6rem;
    border: 1px solid #333;
    color: #666;
    font-weight: 400;
  }

  .submit_btn {
    height: 4rem;
    width: 100%;
    line-height: 4rem;
    border-radius: 2rem;
    color: #fff;
    background-image: linear-gradient(to right, #0fbf6d, #108b30);
    font-size: 1.6rem;
    border: none;
    font-weight: 600;
  }
  .fontsi5 {
    font-size: 1.4rem;
  }
  .bg_org {
    background-image: linear-gradient(to right, #ff7742, #ff5a4b);
  }
  .marTo20 {
    margin-top: 2rem;
  }
  .bg_org_op {
    background-image: linear-gradient(to right, #ff774285, #ff5a4b82);
  }
}
.van-step--horizontal:nth-of-type(1) .van-step__line{
  left:4.3rem;
  overflow: hidden;
  width: 9rem;
}
.van-step--horizontal:nth-of-type(2) .van-step__line{
  left:3.2rem;
  overflow: hidden;
  width:8.7rem;
}
.van-step--horizontal:nth-of-type(3) .van-step__line{
  display: none;
}
.van-step__circle-container{
  background-color: #fbfbfb  !important;
}
.order_detail {
    font-weight: 600;
  width: calc(100% - 2rem);
  margin: 1rem auto 1rem;
  font-size: 1.7rem;
  .ma_bo_20 {
    margin-bottom: 2rem;
  }
  .or_de_33 {
    color: #333;
  }
  .or_de_money {
    color: #f84737;
  }
  .re_points {
    text-align: right;
    font-size: 1.4rem;
    color: #f9591b;
    margin-top: -1rem;
  }
  .or_de_bo10 {
    margin-bottom: 1rem;
  }
  .or_de_discount {
    text-align: right;
    color: #f9591b;
    font-size: 1.4rem;
    font-weight: 400;
  }
  .or_de_bo20 {
    margin-bottom: 2rem;
  }
  .or_de_account {
    font-size: 1.3rem;
    color: #999;
    margin-top: -1.5rem;
    font-weight: 400;
  }
  .or_de_bo5 {
    margin-bottom: 1rem;
  }
  .or_de_bo30 {
    margin-bottom: 3rem;
  }
  .or_de_bo15 {
    margin-bottom: 1.5rem;
  }
  .or_de_co66 {
    color: #666666 !important;
  }
  .executive{
    font-weight: normal;
  }
  .or_de_hotel_name {
    color: #333;
    font-size: 1.6rem;
  }
  .or_de_arrow {
    font-size: 1.2rem;
    color: #999999;
    text-align: right;
    font-weight: 400;
  }
  .arrow {
    font-size: 1.2rem;
    color: #999999;
    top: 0.2rem;
  }
  .or_de_address {
    color: #666666;
    font-size: 1.3rem;
    margin-bottom: 2rem;
    font-weight: 400;
  }
  .or_de_addressBox {
    color: #666666;
    font-size: 1.3rem;
    text-align: center;
    img {
      width: 1.8rem;
      height: 2rem;
    }
    p {
      margin-top: 0.7rem;
      font-weight: 400;
    }
  }
  .or_de_telBox {
    text-align: center;
    img {
      width: 2rem;
      height: 2rem;
    }
    p {
      color: #666666;
      font-size: 1.3rem;
      margin-top: 0.3rem;
      font-weight: 400;
    }
  }
  .or_de_99 {
    font-size: 1.6rem;
    color: #999;
    font-weight: 400;
  }
  .or_de_co_33 {
    color: #333;
    font-size: 1.6rem;
  }
  .or_de_day_number {
    color: #999999;
    font-size: 1.3rem;
    margin: 0 0.6rem;
    font-weight: 400;
  }
  .tel_show {
    margin-top: 0.5rem;
    margin-left: 1rem;
    width: 1.8rem;
    height: 1.2rem;
  }
  .or_de_more {
    color: #333333;
    font-size: 1.7rem;
  }
  .or_de_more_icon {
    text-align: right;
    color: #999;
    font-size: 1.2rem;
  }
  .guess_like {
    color: #333333;
    font-size: 1.7rem;
    margin-bottom: 3rem;
  }
  .or_de_integral {
    color: #f9591b;
    font-size: 1.7rem;
  }
  .or_de_give {
    color: #108b30;
    font-size: 1.4rem;
    text-align: right;
    font-weight: 400;
  }

  .step_div {
    margin-top: 4.2rem;
  }
  .step_title {
    font-size: 1.4rem;
    color: #333;
    font-weight: 600;
    padding-top: 1rem;
  }

  .step_time {
    color: #999;
    font-size: 1.2rem;
    margin-top: 0.4rem;
    font-weight: 400;
  }
}
 .step_divs .van-icon-passed::before{
    position: relative;
    left:-0.9rem;
   }
    .step_divs .van-icon-checked::before{
    position: relative;
    // left:-0.9rem;
    left: -0.9rem;
   }
// /deep/ .van-icon-clear {
//   background: linear-gradient(to right, #f41a3c, #fc740c);
//   background-clip: text;
//   color: transparent !important;
// }
.van-icon-checked::before{
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/checked.png");
  background-size: 100% 100%;
  width: 2.2rem;
  height: 2.2rem;
}
.van-icon-clear::before{
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/clear.png");
  background-size: 100% 100%;
  width: 2.2rem;
  height: 2.2rem;
}
.van-icon-passed::before{
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/passed.png");
  background-size: 100% 100%;
  width: 2.2rem;
  height: 2.2rem;
}
.van-step--finish .van-icon-passed::before{
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/checked.png");
  background-size: 100% 100%;
  width: 2.2rem;
  height: 2.2rem;
}
.van-steps{
  background-color: #fbfbfb !important;
}
// .van-step--process .van-step__line{
//   background:url("../../../assets/hotel/img/order/bor_ccc.png") !important;
//    background-size: 100% 100%;
//    background-position: center center !important;
// }
.van-step--horizontal:not(:last-of-type) .van-step__line{
  background:url("../../../assets/hotel/img/order/bor_ccc.png");
  background-size: 100% 100%;
  background-position: center center !important;
}
.van-step--finish .van-step__line{
  background:url("../../../assets/hotel/img/order/bor_green.png") !important;
  background-position: center center !important;
  background-size: 100% 100% !important;
}
.van-popup--center {
  width: 70%;
  border-radius: 1rem;
  .box {
    img {
      display: block;
      width: 100%;
    }
    .title {
      color: #333;
      font-size: 1.5rem;
      font-weight: 600;
      line-height: 4.7rem;
      margin-top: 0.8rem;
      text-align: center;
    }
    .tips {
      color: #333;
      font-size: 1.3rem;
      line-height: 1.8rem;
      text-align: center;
      margin-bottom: 3rem;
    }
    span {
      float: left;
      width: 50%;
      border-top: solid 1px #f2f2f2;
      line-height: 4.3rem;
      color: #999;
      font-size: 1.4rem;
      text-align: center;
      // display: inline-block;
    }
    .right {
      color: #e6212f;
      width: calc(50% - 0.2rem);
      border-left: solid 1px #f2f2f2;
    }
  }
}
.isiOSX {
  padding-top: 4.4rem;
}
.order-detail-loading {
    font-weight: 600;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  img {
    width: 35%;
    margin-top: 65%;
  }
}
</style>
